import React from "react";
import { useStore } from "../../../../stores/store";

const Text = () => {
  const formElementStyle = "flex items-center my-2";
  const labelElementStyle = "text-md mr-3 w-1/2 flex-1 text-right";
  const inputElementStyle =
    "border border-gray-300 rounded-md p-0.5 w-1/2 text-md";
  const {
    markupText,
    setMarkupText,
    markupFontColor,
    setMarkupFontColor,
    markupFontSize,
    setMarkupFontSize,
    markupFontStyle,
    setMarkupFontStyle,
    markupFontWeight,
    setMarkupFontWeight,
    markupFontFamily,
    setMarkupFontFamily,
  } = useStore();
  return (
    <>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Text:</label>
        <textarea
          placeholder="Enter text"
          className={inputElementStyle}
          value={markupText}
          onChange={(e) => setMarkupText(e.target.value)}
        ></textarea>
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Font Family:</label>
        <select
          className={inputElementStyle}
          value={markupFontFamily}
          onChange={(e) => setMarkupFontFamily(e.target.value)}
        >
          <option value="Arial">Arial</option>
          <option value="Courier New">Courier New</option>
          <option value="Georgia">Georgia</option>
          <option value="Times New Roman">Times New Roman</option>
          <option value="Verdana">Verdana</option>
        </select>
      </div>

      <div className={formElementStyle}>
        <label className={labelElementStyle}>Font Color:</label>
        <input
          value={markupFontColor}
          onChange={(e) => setMarkupFontColor(e.target.value)}
          className={inputElementStyle}
          type="color"
        />
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Font Size:</label>
        <input
          type="number"
          className={inputElementStyle}
          value={markupFontSize}
          onChange={(e) => setMarkupFontSize(Number(e.target.value))}
        />
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Font Style:</label>
        <select
          className={inputElementStyle}
          value={markupFontStyle}
          onChange={(e) => setMarkupFontStyle(e.target.value)}
        >
          <option value="normal">normal</option>
          <option value="italic">italic</option>
          <option value="oblique">oblique</option>
        </select>
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Font Weight:</label>
        <select
          className={inputElementStyle}
          value={markupFontWeight}
          onChange={(e) => setMarkupFontWeight(e.target.value)}
        >
          <option value="normal">normal</option>
          <option value="bold">bold</option>
          <option value="bolder">bolder</option>
          <option value="lighter">lighter</option>
        </select>
      </div>
    </>
  );
};

export default Text;
